{
  "transferLost": "The transfer was lost when the screen reloaded",
  "transferFailed": "The transfer failed",
  "newFolder": "New folder",
  "newFolderName": "Name of the new folder",
  "newName": "New name",
  "oneItem": "“{{name}}”",
  "manyItems_one": "{{count}} item",
  "manyItems_other": "{{count}} items",
  "deleteConfirm": "Delete {{what}} on machine {{node}}? This cannot be undone.",
  "download": "Download here",
  "transferring": "transferring",
  "sendToMachine": "Send to the machine",
  "sendSelected": "Send the selection to the machine",
  "noWritePermission": "No permission to write to the machine",
  "noFolderPicked": "no folder picked",
  "pickedFiles": "picked files",
  "folderEmpty": "The folder is empty.",
  "openLocalFolder": "Open a folder on your own machine — downloaded files will land there.",
  "noDirectoryPicker": "This browser does not show folders. Pick files to send them to the machine; downloaded files it saves on its own.",
  "refreshList": "Refresh the list",
  "folderFailed": "The folder did not open",
  "readingFolder": "Reading the folder…",
  "machineDrives": "machine drives",
  "toMachine": "To the machine",
  "fromMachine": "From the machine",
  "abortAria": "Abort the transfer of {{name}}",
  "retryAria": "Retry the transfer of {{name}}",
  "noStream": "The browser did not hand over the file content as a stream",
  "partialTransfer": "The file was transferred incompletely: {{received}} of {{total}} bytes.",
  "queued": "queued",
  "cancelled": "cancelled",
  "failed": "failed",
  "done": "done · {{size}}",
  "rate": "{{size}}/s",
  "downloadSelected": "Download the selection from the machine",
  "local": "Local",
  "remote": "Remote",
  "size": "Size",
  "modified": "Modified",
  "title": "Files · {{node}}",
  "name": "Name",
  "tightVncAvailable": "TightVNC extension available",
  "secondConnection": "second RFB connection · closes after 5 min idle",
  "noDirectoryAccess": "This browser does not give the page access to folders: it saves fetched files itself, and a large file ends up entirely in the tab memory. For gigabyte-sized files use Chrome or Edge.",
  "openDirectory": "Open folder",
  "pickFiles": "Pick files",
  "queue": {
    "title": "Transfer queue · {{count}}",
    "clearFinished": "Clear finished",
    "limit": "at most {{limit}} at a time · paths with \"..\" are rejected",
    "empty": "Drop files onto the machine panel, or select them and press the arrow."
  }
}
